var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiIconsIrIzquierda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.41 12L15.7125 6.69751L14.655 5.63251L8.28748 12L14.655 18.3675L15.7125 17.3025L10.41 12Z",
    fill: "#003865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiIconsIrIzquierda);
export default __webpack_public_path__ + "static/media/bi-icons-ir-izquierda.b2936fd699cc45e490152373c6618345.svg";
export { ForwardRef as ReactComponent };